import { ValidatorFn, AbstractControl } from '@angular/forms';

export function NumberOfRecipientsValidator(
  maxRecipients: number,
  recipientsCountFn: Function
): ValidatorFn {
  return (c: AbstractControl): { [key: string]: boolean } | null => {
    let recipientsCount = recipientsCountFn();
    let result = { tooManyRecipients: false, noRecipients: false };

    result.tooManyRecipients = recipientsCount > maxRecipients;
    result.noRecipients = recipientsCount === 0;

    return result.tooManyRecipients || result.noRecipients ? result : null;
  };
}
